module.exports = __webpack_public_path__ + "img/Frame1.f09bb86f.png";